import { Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import clsx from 'clsx'
import SubmitButton from 'components/common/submitButton'
import PhotosForm, { PhotosFormState } from 'components/forms/establishment/photosForm'
import SignUpActions from 'components/layouts/components/signUpActions'
import SignUpContent from 'components/layouts/components/signUpContent'
import React from 'react'
import { Trans } from 'react-i18next'
import EstablishmentCreateView from './establishmentCreateView'
import { useStyles } from './styles.css'

interface Props {
    step: number
    steps: number
    onSubmit: (values: PhotosFormState) => void
    inProgress: boolean
    initialValues: Omit<PhotosFormState, 'flag'>
    onPrevious: () => void
    previousInProgress: boolean
    hasWebsiteImage: boolean
}

const EstablishmentPhotosView: React.FC<Props> = ({
    step,
    steps,
    onPrevious,
    previousInProgress,
    inProgress,
    hasWebsiteImage,
    ...formData
}) => {
    const classes = useStyles()

    return (
        <PhotosForm inProgress={inProgress} {...formData}>
            {(content, actions) => (
                <>
                    <SignUpContent>
                        <EstablishmentCreateView step={step} steps={steps}>
                            <Typography variant="h1" color="textSecondary" className={classes.title}>
                                <Trans i18nKey="views.establishment.photos.title" />
                            </Typography>
                            <Typography variant="h2" color="textSecondary" className={classes.subtitle}>
                                <Trans i18nKey="views.establishment.photos.subtitle" />
                            </Typography>
                            <Alert severity="info" className={classes.alert}>
                                {hasWebsiteImage ? (
                                    <Trans
                                        i18nKey="views.establishment.photos.infoWebsite"
                                        components={[<strong />]}
                                    />
                                ) : (
                                    <Trans
                                        i18nKey="views.establishment.photos.info"
                                        components={[<strong />]}
                                    />
                                )}
                            </Alert>
                            {content}
                        </EstablishmentCreateView>
                    </SignUpContent>
                    <SignUpActions>
                        <SubmitButton
                            variant="contained"
                            onClick={onPrevious}
                            loading={previousInProgress}
                            disabled={inProgress}
                        >
                            <Trans i18nKey="actions.previous" />
                        </SubmitButton>
                        {actions.map((action, index) => (
                            <SubmitButton
                                key={index}
                                variant="contained"
                                color="primary"
                                {...action}
                                className={clsx(action.className)}
                            />
                        ))}
                    </SignUpActions>
                </>
            )}
        </PhotosForm>
    )
}

export default EstablishmentPhotosView
